import {Component, Inject, OnInit, PLATFORM_ID} from '@angular/core';
import {ModalInterface} from "../../modal.interface";
import {Observable, Subject} from "rxjs";
import {ModalStateEvent} from "../../modal-state-event";
import {UntypedFormGroup} from "@angular/forms";

import {RxFormBuilder, RxwebValidators} from "@rxweb/reactive-form-validators";
import {ModalState} from "../../modal-state.enum";
import {isPlatformBrowser} from "@angular/common";
import {SelectItem} from "primeng/api";
import {TranslateService} from "@ngx-translate/core";
import {ViolationRestService} from "../../../../api/services/violation.rest.service";
import {ViolationApiModel} from "../../../../api/models/violation.api-model";
import {plainToInstance} from "class-transformer";
import {ResponseNotificationService} from "../../../../core/services/response-notification.service";
import {ViolationTypeEnum} from "../../../../core/enums/violation-type.enum";

@Component({
  selector: 'app-violation',
  templateUrl: './violation.component.html',
  styleUrls: ['./violation.component.scss'],
})
export class ViolationComponent implements ModalInterface, OnInit {
  data: any;
  subjectObject: any;
  type: ViolationTypeEnum;
  subject: Subject<ModalStateEvent>;
  state: Observable<ModalStateEvent>;
  public form: UntypedFormGroup;
  public reasons: SelectItem[] = [
    {
      label: this.translate.instant('shared.modal.modal_service.report_violation.reason.inappropriate_content'),
      value: 'INAPPROPRIATE_CONTENT',
    },
    {
      label: this.translate.instant('shared.modal.modal_service.report_violation.reason.off_topic'),
      value: 'OFF_TOPIC',
    },
    {
      label: this.translate.instant('shared.modal.modal_service.report_violation.reason.profanity'),
      value: 'PROFANITY',
    }
  ]

  constructor(
    @Inject(PLATFORM_ID) public platformId: object,
    private fb: RxFormBuilder,
    private translate: TranslateService,
    private violationRS: ViolationRestService,
    private rns: ResponseNotificationService
  ) { }

  ngOnInit(): void {
    this.subjectObject = this.data['subject'];
    this.type = this.data['type'];
    this.createForm();
    this.state.subscribe((mse: ModalStateEvent) => {
      switch (mse.status) {
        case ModalState.PENDING: this.submit();
      }
    })
  }

  private createForm() {
    // const validators: Validators[] = [RxwebValidators.required(), RxwebValidators.minLength({value: 3}), RxwebValidators.maxLength({value: 255})];
    this.form = this.fb.group(
      {
        reason: [null, [RxwebValidators.required()]],
        details: [null, [RxwebValidators.required(), RxwebValidators.minLength({value: 3})]],
      }
    );

    this.form.valueChanges.subscribe(() => {
      if (this.form.valid) {
        this.subject.next(new ModalStateEvent(ModalState.VALID));
      }
    });
  }

  public submit(): void {
    if (this.form.valid) {
        const violationAM =  plainToInstance(ViolationApiModel, this.form.value);
        violationAM.subject = this.subjectObject['@id'];
        violationAM.reason = this.form.get('reason').value.value;
        violationAM.type = this.type;
        this.violationRS.create(violationAM).subscribe((violationAM: ViolationApiModel) => {
            this.subject.next(new ModalStateEvent(ModalState.SUCCESS, violationAM));
            this.rns.emitMessage(this.translate.instant('shared.modal.modal_service.report_violation.success'));
        });
    } else {
      this.form.markAllAsTouched();
      this.subject.next(new ModalStateEvent(ModalState.INVALID));
    }
  }

  public readonly isPlatformBrowser = isPlatformBrowser;
}
